<script setup>
import CardElement from "./partials/CardElement.vue";
import {computed, onMounted} from "vue";
import { useStore } from "vuex";
import StripeInfo from "./partials/StripeInfo.vue";

const props = defineProps({
  amountDue: {
    type: String,
    default: null,
  },
  currency: {
    type: String,
    default: 'GBP',
  },
  buttonText: {
    type: String,
    default: null,
  },
  clientSecret: {
    type: String,
    default: null,
  },
  cardHolderName: {
    type: String,
    default: null,
  },
});

const store = useStore();
const name = computed({
  get(){
    return store.getters['billing/cardHolderName'];
  },
  set(value) {
    store.dispatch('billing/setCardHolderName', { name: value });
  },
});
const stripe = computed(() => store.getters['billing/stripe']);
const processing = computed(() => store.getters['billing/processing']);
const amountDueFormatted = computed(() =>
  (props.amountDue / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: props.currency
  }
))

onMounted(async () => {
  name.value = props.cardHolderName;
  await store.dispatch('billing/setupStripe', {
    clientSecret: props.clientSecret,
  });
});

const submit = async () => {
  await store.dispatch('billing/payAndSaveCardAsDefault');
}
</script>

<template>
  <div class="form-group xs-mb-20">
    <h1 class="font-size-18">
      Pay outstanding invoice
    </h1>

    <div class="form-group xs-pt-5 my-3">
      <input
        v-model="name"
        type="text"
        placeholder="Card Holder Name"
        required
        class="form-control card-holder-name-input"
      >
    </div>

    <CardElement v-if="stripe" />

    <div class="my-4">
      <button
        id="submit_button"
        class="btn btn-block btn-success order-btn text-bold"
        :disabled="processing"
        @click="submit"
      >
        <template v-if="processing">
          <i class="fas fa-sync fa-spin xs-mr-5" /> Processing
        </template>
        <template v-else>
          {{ buttonText ? buttonText : `Pay ${amountDueFormatted}` }}
        </template>
      </button>
    </div>

    <div class="stripe-text xs-mt-15 sm-mt-30">
      <StripeInfo />
    </div>
  </div>
</template>

<style scoped>
  .card-holder-name-input{
    border: 2px solid #e3e2e2;
    font-size: 16px;
    height: 60px;
  }
</style>
